<template>
    <div class="">
        <div class="w-full">
            <div class="xl:-ml-40">
                <div class="flex justify-center">
                    <div class="border p-8 rounded-md">
                        <h1 class="text-2xl font-bold py-7">
                            Sorry, You have reached your allowed limit of job
                            posts.
                        </h1>
                        <p
                            class="mt-9 flex space-x-3 text-lg leading-6 text-gray-500 dark:text-gray-400"
                        >
                            <span>Let us know here</span>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-6 h-6"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                                />
                            </svg>

                            <a
                                href="mailto: info@opencdljobs.com"
                                class="text-blue-500"
                                >info@opencdljobs.com</a
                            >
                        </p>
                        <Link
                            :href="route('recruiter.jobs')"
                            class="w-full lg:mt-6 flex lg:justify-start gap-4 text-blue-600 items-center hover:scale-105 duration-150 py-2 rounded-md"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="2"
                                stroke="currentColor"
                                class="w-6 h-6 flex-shrink-0"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                                />
                            </svg>

                            <p class="tracking-wider text-sm">Back to jobs</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import RecruitersLayout from "@/components/Layouts/RecruitersLayout.vue";

export default {
    layout: RecruitersLayout,
};
</script>
<script setup>
import { Link } from "@inertiajs/inertia-vue3";

const route = window.route;
</script>
